module.exports = __webpack_public_path__ + "static/media/dekton-white.92287d96.svg";